require('./cardMobileRechargeSuccessStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

//@helper
const { formatCurrency } = require('utilities/currencyHelper');

// @ constants
const { FIRST_STEP } = require('constants/index');

class cardMobileRechargeSuccessStep extends React.Component {
    render() {
        const { immCard, immCardMobileRecharge } = this.props;
        const selectedAmount = immCardMobileRecharge.get('steps').get(FIRST_STEP).get('selectedAmount');
        const amount = selectedAmount.get('amount');
        const currency = formatCurrency(selectedAmount.get('currency'));
        const title = formatText('cardMobileRecharge-successStepInfoText', [amount, currency]);
        const cardAlias = immCard.get('alias').get('current');
        const goBackButtonLabel = formatText('cardMobileRecharge-successStepBackToCardLink', [cardAlias]).toUpperCase();
        const linkToMovements = `/myprofile/cards/${immCard.get('cardId')}/movements`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        }
        const mobilePhone = `+ ${immCardMobileRecharge.get('steps').get(FIRST_STEP).get('mobilePhone')}`;

        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                <WizardSuccess successMessage={title} mainButton={goBackButton}>
                    <section className="row">
                        <div className="col-xs-6 col-md-7">
                            <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                        </div>

                        <div className="col-xs-6 col-md-5">
                            <FormattedText
                                value="cardMobileRecharge-successStepMobileText"
                                className="card-mobile-recharge-success__info-text card-mobile-recharge-success__info-text--light"
                            />
                            <span className="card-mobile-recharge-success__info-text">
                                {mobilePhone}
                            </span>
                        </div>
                    </section>
                </WizardSuccess>
            </div>
        )
    }
}

cardMobileRechargeSuccessStep.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardMobileRecharge: PropTypes.object.isRequired
};

module.exports = cardMobileRechargeSuccessStep;
